import { render, staticRenderFns } from "./ui-date-time-picker.vue?vue&type=template&id=253c4e6b&"
import script from "./ui-date-time-picker.vue?vue&type=script&lang=ts&"
export * from "./ui-date-time-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports